import React from 'react';

const ClockIcon = (iconProps) => (
  <svg
    height="13"
    viewBox="0 0 13 13"
    width="13"
    xmlns="http://www.w3.org/2000/svg"
    {...{ height: 13, width: 13, ...iconProps }}
  >
    <mask id="clock-mask" fill="#fff">
      <path
        d="m.00000956.01148971h12.98851034v12.98850649h-12.98851034z"
        fill="#fff"
        fillRule="evenodd"
      />
    </mask>
    <g fill="#6b6b6b" fillRule="evenodd">
      <path d="m9.25195027 6.23458944h-1.75585082v-2.35188416c0-.48670688-.33557154-.88270528-.74804972-.88270528s-.74804973.3959984-.74804973.88270528v3.1550619c0 .53056892.36581413.96223282.81544545.96223282h2.43650482c.41247818 0 .74804973-.39597739.74804973-.88270528 0-.4867279-.33557155-.88270528-.74804973-.88270528" />
      <path
        d="m6.49425515 11.2351697c-2.61198677 0-4.72941912-2.11743235-4.72941912-4.72941911 0-2.61200588 2.11743235-4.72943824 4.72941912-4.72943824 2.61200588 0 4.72943825 2.11743236 4.72943825 4.72943824 0 2.61198676-2.11743237 4.72941911-4.72943825 4.72941911m0-11.22368382c-3.58666177 0-6.49424559 2.90756471-6.49424559 6.49426471 0 3.58668091 2.90758382 6.49424561 6.49424559 6.49424561 3.58668085 0 6.49426475-2.9075647 6.49426475-6.49424561 0-3.5867-2.9075839-6.49426471-6.49426475-6.49426471"
        mask="url(#clock-mask)"
      />
    </g>
  </svg>
);

export default ClockIcon;
